
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_1mlxs_13",
  "warning-icon-shake-wrapper": "awsui_warning-icon-shake-wrapper_14mhv_1mlxs_14",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_1mlxs_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_1mlxs_44",
  "warning-icon-scale-wrapper": "awsui_warning-icon-scale-wrapper_14mhv_1mlxs_45",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_1mlxs_1",
  "warning": "awsui_warning_14mhv_1mlxs_14",
  "error": "awsui_error_14mhv_1mlxs_13",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_1mlxs_1",
  "root": "awsui_root_14mhv_1mlxs_96",
  "label": "awsui_label_14mhv_1mlxs_129",
  "info": "awsui_info_14mhv_1mlxs_145",
  "description": "awsui_description_14mhv_1mlxs_151",
  "constraint": "awsui_constraint_14mhv_1mlxs_152",
  "hints": "awsui_hints_14mhv_1mlxs_159",
  "constraint-has-validation-text": "awsui_constraint-has-validation-text_14mhv_1mlxs_160",
  "secondary-control": "awsui_secondary-control_14mhv_1mlxs_164",
  "controls": "awsui_controls_14mhv_1mlxs_168",
  "label-hidden": "awsui_label-hidden_14mhv_1mlxs_168",
  "label-wrapper": "awsui_label-wrapper_14mhv_1mlxs_171",
  "control": "awsui_control_14mhv_1mlxs_168",
  "error__message": "awsui_error__message_14mhv_1mlxs_198",
  "warning__message": "awsui_warning__message_14mhv_1mlxs_199",
  "visually-hidden": "awsui_visually-hidden_14mhv_1mlxs_203"
};
  